export default __webpack_public_path__ + "static/media/kitties-on-stool.165fa941.png";